<template>
  <div
    :class="[
      'table-card-search-header',
      'ui-mobile-12'
    ]"
  >
    <div
      :class="{
        'table-card-search-header__content': true,
        'table-card-search-header--content-mobile': showActionsMobile,
        'ui-g-w-md': true,
        'ui-mobile-12': true
      }"
    >
      <UiInput
        v-model.trim="pValue"
        :class="[
          'form-groups',
          'ui-mobile-12',
          'ui-g-md'
        ]"
        is-search
        @search="search"
        @clear="clearInput"
      />
      <div
        v-if="hasActions"
        :class="{
          'table-card-search-header__actions': true,
          'table-card-search-header__actions--show-mobile': showActionsMobile,
          'ui-g-md': true
        }"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableCardSearchHeader',
  props: {
    modelValue: [Number, String],
    placeholder: String,
    showActionsMobile: Boolean,
  },
  emits: ['search', 'input'],
  data() {
    return {
      pValue: '',
    };
  },
  computed: {
    hasActions() {
      return !!this.$slots.actions;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        this.pValue = value;
      },
    },
  },
  methods: {
    clearInput() {
      this.setValue('');
      this.search();
    },
    setValue(value) {
      this.pValue = value;
      this.$emit('input', value);
    },
    search() {
      this.$emit('search', this.pValue);
    },
  },
};
</script>

<style lang="scss">
  .table-card-search-header {
    display: flex;
    // width: 100%;

    &__content {
      align-items: baseline;
    }

    &__actions {
      display: flex;
      // margin-left: 8px;

      &--show-mobile {
        display: none;
      }
    }

    @media (max-width: 650px) {
      width: 100%;
      // margin-bottom: 10px;

      &__content {
        flex-wrap: wrap;

        &--mobile {
          flex-wrap: nowrap;
          width: auto;
          flex-grow: 0;
        }
      }

      &__actions {
        margin-left: 0;
        flex-wrap: wrap;
        width: 100%;

        &--show-mobile {
          display: block;
          flex-grow: 0;
          width: auto;
        }
      }
    }
  }
</style>
